import React, { Component } from "react";
import { Container } from "react-bootstrap";
import PortfolioCardView from "./portfoliocardview";
import PortfolioUtils from "./PortfolioUtils";
import "./Portfolio.css";
import { Row, Col } from "react-bootstrap";

class PorfolioView extends Component {
  state = {
    portfolioList: PortfolioUtils.portfolios,
  };
  render() {
    return (
      <div id="portfolio">
        <div style={{ textAlign: "center", margin: "3rem" }}>
            <span className="title">Portfolio</span>
          </div>
      <Container fluid>
        <Row className="justify-content-center">
          {this.state.portfolioList.map((item) => {
            return (
              <Col
                key={item.name || item}
                xs={12}
                sm={6}
                md={4}
                lg={3}
                className="d-flex align-items-stretch"
              >
                <PortfolioCardView {...item} />
              </Col>
            );
          })}
        </Row>
      </Container>
      </div>
    );
  }
}

export default PorfolioView;
